import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCastContext } from '../context/CastContext';
import { castApi } from '../services/castApi';
import { AgentCard } from './AgentCard';
import Typography from '../../../basic/Typography';
import styles from '../Cast.module.css';


export const AgentGallery: React.FC = () => {
  const { state, dispatch } = useCastContext();
  const navigate = useNavigate();

  // Load agents on component mount
  useEffect(() => {
    const loadAgents = async () => {
      dispatch({ type: 'LOAD_AGENTS_START' });
      try {
        const agents = await castApi.listAgents();
        dispatch({ type: 'LOAD_AGENTS_SUCCESS', payload: agents });
      } catch (error) {
        dispatch({
          type: 'LOAD_AGENTS_ERROR',
          payload: error instanceof Error ? error.message : 'Failed to load agents'
        });
      }
    };

    loadAgents();
  }, [dispatch]);

  const handleAgentSelect = (agent: any) => {
    dispatch({ type: 'SELECT_AGENT', payload: agent });
    navigate(`/cast/${agent.id}`);
  };

  const handleCreateAgent = () => {
    navigate('/cast/create');
  };

  if (state.loading.agents) {
    return (
      <div className={styles['agent-gallery-loading']}>
        <div className={styles['loading-spinner']}></div>
      </div>
    );
  }

  if (state.error) {
    return (
      <div className={styles['agent-gallery-error']}>
        <div className={styles['error-message']}>
          <Typography variant="h3" gutterBottom={true}>
            Error Loading Agents
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            {state.error}
          </Typography>
          <button
            className={styles['retry-button']}
            onClick={() => window.location.reload()}
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles['agent-gallery']}>
      <div className={styles['gallery-header']}>
        <Typography variant="h2" gutterBottom={false}>
          Available Agents
        </Typography>
        <button
          className={`${styles['create-agent-button']} ${styles['apple-style-button']}`}
          onClick={handleCreateAgent}
        >
          Create New Agent
        </button>
      </div>

      {state.agents.length === 0 ? (
        <div className={styles['no-agents']}>
          <Typography variant="h3" gutterBottom={true}>
            No Agents Available
          </Typography>
          <Typography variant="body1" gutterBottom={true}>
            Create your first agent to get started!
          </Typography>
          <button
            className={styles['create-first-agent-button']}
            onClick={handleCreateAgent}
          >
            Create Your First Agent
          </button>
        </div>
      ) : (
        <div className={styles['agents-grid']}>
          {state.agents.map((agent) => (
            <AgentCard
              key={agent.id}
              agent={agent}
              onClick={handleAgentSelect}
            />
          ))}
        </div>
      )}
    </div>
  );
};